module.exports = __webpack_public_path__ + "img/Logo_Ford.265e28f1.svg";